export default __webpack_public_path__ + "static/media/cointelegraph.88ba4d11.png";